import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whatWeShipSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/what-we-ship-page'

interface WhatWeShipPageProps {}

const WhatWeShipPage: React.FC<WhatWeShipPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[297px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[244px] w-[280px] h-[44px]'
        className='xl-min:[&>div:first-child]:!max-w-[745px] lg-mn:[&>div:first-child]:max-w-[436px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full md-mn:[&_article]:px-0 
          [&_article]:px-6 
          [&_h3]:text-center 
          xl-min:[&_button]:!w-[263px]
          md-mn:[&_button]:w-[226px]
          [&_button]:w-[208px]
          `}
      />
      <ServiceTipsSectionSection
        {...whatWeShipSectionContent}
        className='
        md-mn:[&>div>div:nth-of-type(2)]:grid-cols-2 
        xl-min:[&>div>div:nth-of-type(2)]:!grid-cols-3'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        className='
        [&_article]:bg-transparent 
        [&_article]:border-none 
        xl-min:[&>div>div:nth-of-type(2)]:!grid-cols-4 md-mn:[&>div>div:nth-of-type(2)]:grid-cols-2'
        imgClassName='w-[130px] h-[130px]'
      />
      <ForWhoSection {...forWhoSectionContent} className='[&_article]:items-start' />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-full
          [&_h3]:w-[80%] 
          [&_h3]:mx-auto
          xl-min:[&_button]:!w-[185px]
          lg-mn:[&_button]:w-[236px]
          md-mn:[&_button]:w-[229px]
          [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default WhatWeShipPage
